const filter = {
  selected: '已选条件',
  clear: '一键清空',
  remove: '移除{{name}}筛选'
};

export default filter;
